import { Http, http } from '../http'
import { Company } from '../company'

export interface Credit {
  BRANCH_NAME: number
  CONTRACT: string
  CCY_NAME: string
  MAIN_BALANCE: number
  CREDIT_AMOUNT: number
  START_DATE: string
  END_DATE: string
  INT_RATE: number
  PAYMENT_ACCOUNT: string
  PAYMENT_ACC_BALANCE: number
  CUR_INT_AMOUNT: number
  TOTAL_DELAY_AMOUNT: number
  PAID_INT_AMOUNT: number
  DELAY_DAY_COUNT: number
  SENED_NO: string
  PAID_TOTAL_MONTH: string
  STATUS: string
}
export interface CreditPlan {
  PAYMENT_DATE: string
  MAIN_AMOUNT: number
  INTEREST_AMOUNT: number
  PAID_AMOUNT: number
}
export const getCredits = async (company: Company): Promise<Credit[]> => {
  const { data } = await http.get<Credit[]>(`credit/${company.customerNo}`)
  // const { data } = await http.get<Credit[]>(`credit/5200565`);
  return data
}

export const getCreditPlan = async (
  company: Company,
  contractNo: string
): Promise<CreditPlan[]> => {
  const { data } = await http.get<CreditPlan[]>(
    `credit/creditplan?customerid=${company.customerNo}&contractNo=${contractNo}`
  )
  // console.log(data);
  return data
}

export const getCreditRealPlan = async (
  company: Company,
  contractNo: string
): Promise<CreditPlan[]> => {
  const { data } = await http.get<CreditPlan[]>(
    `credit/creditrealplan?customerid=${company.customerNo}&contractNo=${contractNo}`
  )
  // const { data } = await http.get<CreditPlan[]>(`http://demo.gaiabilgi.com.tr:7030/eGlobeService/rest/credit/creditrealplan?customerid=5200565&contractNo=23s20-20100o6d02`);
  return data
}

export const getCreditPlanPdf = async (
  lang: any,
  company: Company,
  contractNo: string
): Promise<CreditPlan[]> => {
  const httpNew = new Http(lang)
  const { data } = await httpNew.get<CreditPlan[]>(
    `file/get-credit-plan-pdf/${company.customerNo}/${contractNo}`
  )

  return data
}

export const getCreditRealPlanPdf = async (
  lang: any,
  company: Company,
  contractNo: string
): Promise<CreditPlan[]> => {
  const httpNew = new Http(lang)
  const { data } = await httpNew.get<CreditPlan[]>(
    `file/get-credit-real-plan-pdf/${company.customerNo}/${contractNo}`
  )

  return data
}

export const getCreditPlanExcel = async (
  lang: any,
  company: Company,
  contractNo: string
): Promise<CreditPlan[]> => {
  const httpNew = new Http(lang)
  const { data } = await httpNew.get<CreditPlan[]>(
    `file/get-credit-plan-excel/${company.customerNo}/${contractNo}`
  )

  return data
}

export const getCreditRealPlanExcel = async (
  lang: any,
  company: Company,
  contractNo: string
): Promise<CreditPlan[]> => {
  const httpNew = new Http(lang)
  const { data } = await httpNew.get<CreditPlan[]>(
    `file/get-credit-real-plan-excel/${company.customerNo}/${contractNo}`
  )

  return data
}
